import { render, staticRenderFns } from "./CampaignCard.vue?vue&type=template&id=b7d74f3e&scoped=true&"
import script from "./CampaignCard.vue?vue&type=script&lang=ts&"
export * from "./CampaignCard.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignCard.vue?vue&type=style&index=0&id=b7d74f3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d74f3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardText,VCardTitle,VImg,VSheet})
